import { ERROR_HANDLING_SERVICES } from '../store/actions/types';
import { store } from '../store';
import { internalError } from '../constants/defaultValues';

export const setErrorDispatcher = (
    visible,
    message = internalError.description,
    title = internalError.reason,
    onlyCloseButton = false
) =>
    store.dispatch({
        type: ERROR_HANDLING_SERVICES,
        payload: {
            visible,
            message,
            title,
            onlyCloseButton,
        },
    });
